import { Component, Input } from "@angular/core";
import { NgIf } from "@angular/common";
import { LucideAngularModule } from "lucide-angular";
import { SharedModule } from "../../shared.module";

@Component({
    selector: "app-no-connection-found",
    templateUrl: "./no-connection-found.component.html",
    styleUrls: ["./no-connection-found.component.scss"],
    imports: [NgIf, LucideAngularModule, SharedModule]
})
export class NoConnectionFoundComponent {
    @Input() isUserDeviceOnline = false;
    colorOfWifiIcon: string = "#B0B0B0";
}
